(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-wager/assets/javascripts/generate-wager.js') >= 0) return;  svs.modules.push('/components/numbergames/game-wager/assets/javascripts/generate-wager.js');

'use strict';

const {
  productMapping,
  rules: {
    getRules
  },
  gameWager
} = svs.numbergames;

function getWagerOptionsHandler(rules) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const getProducts = () => {
    var _ref, _options$product;
    const product = (_ref = (_options$product = options.product) !== null && _options$product !== void 0 ? _options$product : rules.productId) !== null && _ref !== void 0 ? _ref : '';
    if (!Array.isArray(options === null || options === void 0 ? void 0 : options.products)) {
      return productMapping.getAllItsIds(product);
    }
    return Array.from(new Set(options.products.flatMap(productMapping.getAllItsIds).filter(itsId => productMapping.getAllItsIds(product).includes(itsId))));
  };
  const getHasLotto2 = () => {
    var _options$hasLotto;
    return rules.hasLotto2 ? Boolean((_options$hasLotto = options.hasLotto2) !== null && _options$hasLotto !== void 0 ? _options$hasLotto : rules.hasLotto2) : undefined;
  };
  const getIsSubscription = () => Boolean(rules.hasSubscription) && Boolean(options.isSubscription);
  const getDrawCount = () => {
    const drawCount = options.drawCount;
    if (drawCount < 1 || !Number.isInteger(drawCount) || getIsSubscription()) {
      return 1;
    }
    return drawCount;
  };
  return {
    getProducts,
    getHasLotto2,
    getIsSubscription,
    getDrawCount
  };
}

function generateWager(options) {
  var _options;
  if (!((_options = options) !== null && _options !== void 0 && _options.product) && ['number', 'string'].includes(typeof options)) {
    options = {
      product: options
    };
  }
  const productId = productMapping.getProductId(options.product);
  const rules = getRules(productId);
  if (!rules) {
    gameWager.logger.warn("Can not generate wager. Could not find rules for ".concat(options.product));
    return;
  }
  const wagerOptionsHandler = gameWager.getWagerOptionsHandler(rules, options);
  return {
    productId,
    boards: gameWager.generateBoards(productId, options.boardOptions),
    joker: gameWager.generateJoker(productId, options.jokerOptions),
    products: wagerOptionsHandler.getProducts(),
    hasLotto2: wagerOptionsHandler.getHasLotto2(),
    drawCount: wagerOptionsHandler.getDrawCount(),
    isSubscription: wagerOptionsHandler.getIsSubscription()
  };
}
Object.assign(svs.numbergames.gameWager, {
  getWagerOptionsHandler,
  generateWager
});

 })(window);